// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3mmL0","label":"Labeled_label__vxl9j","divider":"Labeled_divider__Z9h10"};